var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyHeart = function SvgEmptyHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A1629",
    fillRule: "evenodd",
    d: "M12.051 1.078a5.417 5.417 0 0 1 5.905 8.836l-7.367 7.367a.833.833 0 0 1-1.178 0L2.044 9.914a5.418 5.418 0 0 1 7.662-7.662l.294.295.294-.294a5.4 5.4 0 0 1 1.757-1.175m2.074 1.254a3.75 3.75 0 0 0-2.652 1.099l-.884.883a.833.833 0 0 1-1.178 0l-.884-.883a3.751 3.751 0 1 0-5.305 5.305L10 15.513l6.777-6.777a3.752 3.752 0 0 0-2.652-6.404",
    clipRule: "evenodd"
  })));
};
export default SvgEmptyHeart;